import { render } from "./PanelFaena.vue?vue&type=template&id=4ce94de8"
import script from "./PanelFaena.vue?vue&type=script&lang=js"
export * from "./PanelFaena.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/monitor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__